/* eslint-disable import/no-cycle */
import { Util } from '@libs/utilities/util';
import { Stats } from '@libs/utilities/stats';

import { IAmazonCompositeKeywordData } from '../../../../constants/research';
import { AmazonSvEvaluatorService } from '../search-volume/amazon-sv-evaluator.service';
import { RelevanceScoreEvaluatorService } from './relevance-score-evaluator.service';


export class PotentialScoreEvaluatorService {

	constructor(
		private amazonSvEvaluatorService		: AmazonSvEvaluatorService,
		private relevanceScoreEvaluatorService	: RelevanceScoreEvaluatorService
	) {}


	organicRankPotential(keywordData: IAmazonCompositeKeywordData): number {

		//0 - calculate the chance of the product to sell
		const page1Reviews	: number = keywordData.amazon.competition.reviews.count.page1;
		const totalProducts	: number = keywordData.amazon.competition.totalProducts;
		const ratioOfSold   : number = page1Reviews * 2 / totalProducts;

		//1 - factor in the ads competition
		const amazonCmp		: number = 1 - (this.amazonSvEvaluatorService.cmp(keywordData) ?? 0) / 100;
		const chanceToSell	: number = ratioOfSold * 0.4 + ratioOfSold * amazonCmp * 0.6;

		//2 - obfuscate the value
		const obfuscatedOrganicPotential: number = Math.round(Util.Number.toSaveNumber(Util.Crypto.obfuscateBy10Percent(chanceToSell * 100), 0, 100));
		return obfuscatedOrganicPotential;
	}

	adPotential(keywordData: IAmazonCompositeKeywordData): number {

		//0 - competition and how expensive ads are
		const amazonCmp		: number = (this.amazonSvEvaluatorService.cmp(keywordData) ?? 0) / 100;
		const amazonCpc		: number = this.amazonSvEvaluatorService.cpcAvg(keywordData) ?? 0;
		const adClickChance : number = 1 - (1 / (2 / amazonCpc));

		//1 - calculate the clothing relevance
		const clothingRelevance: number = this.relevanceScoreEvaluatorService.clothingRelevance(keywordData);
		const clothingExtreme  : number = Stats.Regression.linearRangeFit([[0, 0], [0.75, 0.2], [1, 1]], clothingRelevance);

		//2 - calculate the ad potential (by how expensive are ads + how much competition + how clothing relevant is the niche)
		const estAdPotential: number = adClickChance * 0.2 + (1 - amazonCmp) * 0.2 + clothingExtreme * 0.6;

		//3 - obfuscate the value
		const obfuscatedAdPotential: number = Math.round(Util.Number.toSaveNumber(Util.Crypto.obfuscateBy10Percent(estAdPotential * 100), 0, 100));
		return obfuscatedAdPotential;
	}
}
